// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__CFW5X","content":"footer_content__lrAkr","icons":"footer_icons__cX0sW"};